/**
 * Api.Constant.ts
 * This Component is used to define endpoint commonly.
 */

export const ApiSignin = "/signIn";
export const ApiSigninWithToken = "/verifyToken";

// Configuration End Points
export const GetCountryList = "/Config/GetCountryList";
export const GetStateList = "/Config/GetStateList";
export const GetDistrictList = "/Config/GetDistrictList";
export const GetConfigParamDataList = "/Config/GetConfigParamDataList";
export const GetConfigGroups = "/Config/GetConfigGroups";
export const AddEditConfigGroup = "/Config/AddEditConfigGroup";
export const GetSpecificConfigGroup = "/Config/GetSpecificConfigGroup";
export const GetSpecificConfigParamData = "/Config/GetSpecificConfigParamData";
export const AddEditConfigInfo = "/AddEditConfigInfo";
export const GetMenuHierarchyList = "/getMenuHierarchy";
export const GetVersionInfo = "/GetVersionInfo";

// USER MANAGEMENT
export const GetUserList = "/GetUserList";
export const AddEditUser = "/addEditUser";
export const GetSpecificUserData = "/GetSpecificUser";
export const GetReviewerList = "/getReviewerList";
export const GetRoleList = "/getRoleList";
export const GetSpecificRoleInformation = "/getSpecificRole";
export const AddOrUpdateRoleInformation = "/addEditRole";
export const ValidateOTP = "/UserManagement/ValidateOtp";
export const ForgotPassword = "/resetPassword";
export const ResetPassword = "/updatePassword";
export const ForgotPasswordLink = "/forgetPasword";

//Client Management
export const GetAllClients = "/getAllClients";
export const AddEditClient = "/addEditClient";
export const GetSpecificClient = "/getClientDetails";

// KPI Management
export const GetKPIs = "/getKPIs";
export const AddEditKPI = "/addEditKPI";
export const GetSpecificKPI = "/getSpecificKPI";

// Customer Module End Points
export const GetCustomerList = "/Project/GetCustomerList";
export const AddEditCustomer = "/Project/AddEditCustomer";
export const GetSpecificCustomerData = "/Project/GetSpecificCustomerData";
export const AddEditCustomerPartnerMapping =
  "/Project/AddEditCustomerPartnerMapping";

// Dealer Module End Points
export const GetDealerList = "/Project/GetDealerList";
export const GetSpecificDealerMasterData =
  "/Project/GetSpecificDealerMasterData";
export const GetDealerMasterList = "/Project/GetDealerMasterList";
export const AddEditDealer = "/Project/AddEditDealer";
export const GetSpecificDealerData = "/Project/GetSpecificDealerData";
export const AddEditDealerPartnerMapping =
  "/Project/AddEditDealerPartnerMapping";

// Service Partner End Points
export const AddEditServicePartner = "/Project/AddEditServicePartner";
export const GetServicePartnerList = "/Project/GetServicePartnerList";
export const GetCustMappedPartnerList = "/Project/GetCustMappedPartnerList";
export const GetSpecificServicePartner = "/Project/GetSpecificServicePartner";

// Bulk Upload End Points
export const ImportDealerList = "/BulkUpload/ImportDealerList";
export const ImportTicketList = "/BulkUpload/ImportTicketList";
export const ImportEngineerList = "/BulkUpload/ImportEngineerList";
export const SaveBulkDealerList = "/BulkUpload/SaveBulkDealerList";
export const ApproveADL = "/BulkUpload/ApproveADL";
export const GetBulkUploadSample = "/Reports/GetBulkUploadSample";
export const GetADLErrorReport = "/Reports/GetADLErrorReport";
export const GetTicketCount = "/Reports/GetTicketCount";
export const GetTicketTypeCount = "/Reports/GetTicketTypeCount";
export const GetTicketUploadSample = "/Reports/GetTicketUploadSample";
export const GetEngineerUploadSample = "/Reports/GetEngineerUploadSample";
export const GetUploadedADLData = "/Reports/GetUploadedADLData";
export const GetTicketBulkDataReport = "/Reports/GetTicketBulkDataReport";
export const GetEnggBulkDataReport = "/Reports/GetEnggBulkDataReport";
export const GetServiceInstallationReport =
  "/Reports/GetServiceInstallationReport";
export const GetDealerActiveAssetReport = "/Reports/GetDealerActiveAssetReport";
export const GetYearlyDealerReport = "/Reports/GetYearlyDealerReport";
export const GetSLAReport = "/Reports/GetSLAReport";
export const GetTicketProgressReport = "/Reports/GetTicketProgressReport";
// Ticket Module End Points
export const AddEditTicket = "/Ticket/AddEditTicket";
export const GetTicketList = "/Ticket/GetTicketList";
export const GetSpecificTicket = "/Ticket/GetSpecificTicket";
export const GetSpecificTicketAMCApproval =
  "/Ticket/GetSpecificTicketAMCApproval";
export const AddEditTicketAMCApproval = "/Ticket/AddEditTicketAMCApproval";
export const ReassignTicket = "/Ticket/ReassignTicket";
export const GetSpareDepHistory = "/Ticket/GetSpareDepHistory";
export const AddEditSpareDependency = "/Ticket/AddEditSpareDependency";
export const DeleteTicket = "/Ticket/DeleteTicket";

// Product Module End Points
export const GetProductList = "/Project/GetProductList";
export const AddEditProduct = "/Product/AddEditProduct";
export const GetSpecificProductList = "/Product/GetSpecificProductList";

// Holiday List End Points
export const GetHolidayList = "/Config/GetAllCalendarEvents";
export const AddEditCalendarEvent = "/Config/AddEditCalendarEvent";
export const UpdateChunkAPICount = "/Config/UpdateChunkAPICount";

// Config-state End Points
export const AddEditState = "/Config/AddEditState";
export const AddDistrict = "/Config/AddDistrict";
export const UpdateDistrict = "/Config/UpdateDistrict";
export const GetGroupById = "/Config/GetGroupById";
export const GetIssueCategoryList = "/Config/GetIssueCategoryList";
export const AddEditIssueCategory = "/Config/AddEditIssueCategory";

// Config-spare End Points
export const GetSpareList = "/Product/GetSpareList";
export const AddEditSpare = "/Product/AddEditSpare";
export const GetSpecificSpare = "/Product/GetSpecificSpare";
export const GetSpareProductList = "/Product/GetSpareProductList";

// Logs End Points
export const GetAuditLogList = "/Config/GetAuditLogList";

//Dashboard End Points
export const GetDashboardTicketCount = "/Reports/GetDashboardTicketCount";
export const GetDashboardIssueCatData = "/Reports/GetDashboardIssueCatData";
export const GetDashboardSLAData = "/Reports/GetDashboardSLAData";
export const GetDashboardPartnerData = "/Reports/GetDashboardPartnerData";

// Reports End Points,
export const GetAMCSummaryReport = "/Reports/GetAMCSummaryReport";
export const AddEditReportData = "/Reports/AddEditReportData";
export const GetInstallationCostReport = "/Reports/GetInstallationCostReport";
export const GetReportLogsList = "/Reports/GetReportLogsList";
export const GetReportDataList = "/Reports/GetReportDataList";
export const AddEditReportSchedules = "/Reports/AddEditReportSchedules";
export const GetReportSchedulesList = "/Reports/GetReportScheduleList";
export const GetDashboardDailyTicketCount =
  "/Reports/GetDashboardDailyTicketCount";

// Product Rate Module End Points
export const GetCustomerAMCRateList = "/Product/GetCustomerAMCRateList";
export const GetPartnerRateList = "/Product/GetPartnerRateList";
export const AddEditCustomerAMCRate = "/Product/AddEditCustomerAMCRate";
export const AddEditServicePartnerRate = "/Product/AddEditServicePartnerRate";

// project end points
export const AddEditProject = "/addEditProject";
export const GetProjectList = "/getProjectList";
export const GetSpecificProject = "/getSpecificProject";
export const GetSpecificProjectDashboardData =
  "/getSpecificProjectDashboardData";
export const GetTasksList = "/getTaskList";
export const GetTasksListByStatus = "/getTaskListByStatus";

// Projects end points
export const GetProjectCategoryList = "/getProjectCategoryList";
export const AddEditProjectCategory = "/addEditProjectCategory";
export const GetSpecificProjectCategory = "/getSpecificProjectCategory";
export const AddEditWorkCategory = "/addEditWorkCategory";
export const GetWorkCategoryList = "/getWorkCategoryList";
export const GetSpecificWorkCategory = "/getSpecificWorkCategory";
export const GetStatusList = "/getStatusList";
export const AddEditStatus = "/addEditStatus";
export const GetSpecificStatus = "/getSpecificStatus";

// Dashboard end points
export const AddEditTask = "/addEditTask";
export const AddEditWork = "/addEditProjectWorkMapping";
export const GetSpecificWork = "/getSpecificProjectWorkMapping";
export const GetSpecificTask = "/getSpecificTask";
export const AddTaskComment = "/addTaskComments";
export const DeleteDocs = "/deleteDocs";

// Project mapping end points
export const AddEditProjectWorkMapping = "/addEditProjectWorkMapping";
export const AddEditProjectCategoryWorkMapping =
  "/addEditProjectCategoryWorkMapping";
export const AddEditProjectCategoryStatus = "/addEditProjectCategoryStatus";

// Generate Reports
export const GetProjectReportById = "/getProjectReportById";
export const GetEmployeeReport = "/getEmployeeReport";

//Upload task in bulk
export const UploadTaskInBulk = "/uploadTask";

// Notifications
export const GetNotifications = "/getNotifications";
export const MarkNotificationRead = "/updateNotification";

//Designation Management
export const GetDesignations = "/getDesignations";
export const AddEditDesignation = "/addEditDesignation";
export const GetSpecificDesignation = "/getSpecificDesignation";
export const DeleteDesignation = "/deleteDesignation";
export const DeleteKPI = "/deleteKPI";

//Assesment End Points
export const AddEditAssessment = "/addEditAssessment";
export const GetAssessment = "/getAssessments";

export const getSpecificAssessment = "/getSpecificAssessment";
export const addEditAssessmentReview = "/addEditAssessmentReview";
export const getAssessmentByUserId = "/getAssessmentByUserId";
export const employeeAssessmentAction = "/employeeAssessmentAction";


export const getUserAssessmentHistory = "/getUserAssessmentHierarchy";
// export const AddEditPerformance = "/Performance/AddEditPerformance";

// KPI Cycle Management
export const GetKPICycles = "/getCycles";
export const addEditCycle = "/addEditCycle";
export const GetSpecificKPICycle = "/getSpecificCycle";
export const DeleteKPICycle = "/deleteKPICycle";
export const GetActiveCycle = "/getActiveCycle";

// API Manager
export const AddEditCollections = "/addEditCollections";
export const GetCollectionList = "/getCollectionList";
export const AddEditRequest = "/addEditApiDetails";
export const GetSpecificApiDetail = "/getSpecificApiDetails";
export const ImportPostmanCollection = "/importPostmanCollection";
export const MoveCollectionContent = "/moveCollectionContents";
export const DeleteCollection = "/deleteCollection";


